/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum EventSubscriptionResourceType {
    maintenance = 'maintenance',
    failure = 'failure',
    migration = 'migration',
    backtrack = 'backtrack',
    backup = 'backup',
    deletion = 'deletion',
    restoration = 'restoration',
    availability = 'availability',
    recovery = 'recovery',
    failover = 'failover',
    notification = 'notification',
    read_replica = 'read_replica',
    creation = 'creation',
    low_storage = 'low_storage',
    configuration_change = 'configuration_change'
}
